import { Checkbox, CheckboxProps } from '@mui/material'
import { EFCheckBlankIcon } from '../EFIcons'

export const EFCheckbox = (props: CheckboxProps) => {
  return (
    <Checkbox
      disableRipple
      edge={false}
      sx={{ width: 48, height: 48, '&& svg': { width: 24, height: 24 } }}
      icon={<EFCheckBlankIcon />}
      {...props}
    />
  )
}
